import { Component } from '@angular/core';
import { SidepanelService } from './core/sidepanel.service';
import { WhitelabelService } from './domain/whitelabel.service';
import { ChatpanelService } from './core/chatpanel.service';
import { Router, NavigationError, ActivatedRoute, NavigationStart } from '@angular/router';
import { LoginGuardService } from './api/login-guard.service';
import { LangService } from './core/lang.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  title = 'app';
  isCertifiedRelease:boolean;
  isCertifiedReleaseInvalidated:boolean;
  isShowingDevNetFailOverlay:boolean;
  isShowingApiNetFailOverlay:boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginGuard: LoginGuardService,
    private lang: LangService,
    public whiteLabel: WhitelabelService,
  ) {
    this.applySiteLock();
    this.setupRouterDefault();
    this.setupConnectionOverlaySubs()
  }
  
  getLoginReq     = () => this.loginGuard.getLoginReq()
  getDevNetFail   = () => this.loginGuard.getDevNetFail()
  getApiNetFail   = () => this.loginGuard.getApiNetFail()
  getSupportReq   = () => this.loginGuard.getSupportReq()

  setupConnectionOverlaySubs(){
    this.getDevNetFail().subscribe(v => this.isShowingDevNetFailOverlay = v )
    this.getApiNetFail().subscribe(v => this.isShowingApiNetFailOverlay = v )
    this.loginGuard.getConfirmationReq().subscribe(v => this.currentConfirmation = v )
  }

  applySiteLock(){
    const STORE_ADDR = 'site_lock';
    const currentTimestamp = new Date().valueOf();
    const prevTimestamp = window.localStorage.getItem(STORE_ADDR);
    if (prevTimestamp && currentTimestamp < parseFloat(prevTimestamp) ){
      this.isCertifiedRelease = true;
    }
    this.isCertifiedRelease = true; // comment this out before QC release

    if (!this.isCertifiedRelease){
      if (btoa((prompt('Password?')+'').trim().toLowerCase())==='dnJldHRhMjgxMQ=='){ // atob
        this.isCertifiedRelease = true;
        const goodForSeconds = 30*60*1000;
        window.localStorage.setItem(STORE_ADDR, ''+(currentTimestamp + goodForSeconds));
      }
      else{
        this.isCertifiedReleaseInvalidated = true;
      }
    }
  }

  isAuthActive(){
    return this.loginGuard.isAuthActive();
  }

  closeModal(){
    this.loginGuard.confirmationReqDeactivate();
  }

  currentConfirmation:{caption:string, confirm:()=>any };
  confirmModal(){
    this.currentConfirmation.confirm();
    this.loginGuard.confirmationReqDeactivate()
  }

  getCurrentConfirmationCaption(){
    if (this.currentConfirmation){
      return this.currentConfirmation.caption
    }
  }

  dismissSupportPopup(){
    this.loginGuard.supportReqDeactivate()
  }

  gotoHomeScreen(){
    this.router.navigate(['/'])
  }

  setupRouterDefault(){
    this.route.params.subscribe(params => {
      // console.log(params, params)
    })
    this.router.events.subscribe((event)=> {
      if (event instanceof NavigationStart && event.url){
        this.lang.updateCurrentUrl(event.url);
        const routePath = event.url.split('/');
        this.lang.setCurrentLanguage(routePath[1]);
      }
      if (event instanceof NavigationError){
        console.warn('NavigationError', event)
        setTimeout(()=>{
          this.gotoHomeScreen();
        }, 100);
      }
    })
  }
  
}
